import React from 'react';
import styled from 'styled-components';
import { Users, DollarSign, Settings, LayoutDashboard, Star } from 'lucide-react';

const Sidebar = styled.aside`
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  width: 260px;
  background: var(--secondary-black);
  border-right: 1px solid var(--border-color);
  padding: 20px 12px;
  z-index: 10;
`;

const Brand = styled.div`
  color: var(--text-white);
  font-family: var(--font-heading);
  font-weight: 700;
  font-size: 1.25rem;
  padding: 12px 10px 20px 10px;
`;

const Menu = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const Item = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  text-align: left;
  padding: 10px 12px;
  background: ${(p) => (p.$active ? 'rgba(224, 193, 111, 0.12)' : 'transparent')};
  border: 1px solid ${(p) => (p.$active ? 'var(--primary-gold)' : 'transparent')};
  border-radius: 10px;
  color: var(--text-white);
  cursor: pointer;
  transition: all .2s ease;
  &:hover { background: rgba(255,255,255,0.04); }
  svg { color: var(--primary-gold); height: 18px; width: 18px; }
`;

const AdminSidebar = ({ active, onSelect }) => {
  const items = [
    { key: 'overview', label: 'Overview', icon: <LayoutDashboard /> },
    { key: 'users', label: 'Users', icon: <Users /> },
    { key: 'creators', label: 'Creators', icon: <Star /> },
    { key: 'transactions', label: 'Transactions', icon: <DollarSign /> },
    { key: 'settings', label: 'Settings', icon: <Settings /> },
  ];

  return (
    <Sidebar>
      <Brand>Admin</Brand>
      <Menu>
        {items.map((it) => (
          <Item key={it.key} $active={active === it.key} onClick={() => onSelect(it.key)}>
            {it.icon}
            <span>{it.label}</span>
          </Item>
        ))}
      </Menu>
    </Sidebar>
  );
};

export default AdminSidebar;


